import {ApplicationController} from "../support/application-controller";
import {isValidEmail} from "../support/util";

export default class extends ApplicationController {
    static targets = [
        "memberEmail",
        "permissionCheckbox",
        "referrer",
        "error",
        "errorWrapper",
        "warning",
        "warningWrapper",
        "url",
    ];

    hideWarningMessage() {
        if (this.hasWarningWrapperTarget) {
            this.warningTarget.textContent = null;
            this.warningWrapperTarget.classList.add('hidden');
        }
    }

    displayErrorMessage(error) {
        this.hideWarningMessage();
        if (this.hasErrorTarget && this.hasErrorWrapperTarget) {
            this.errorWrapperTarget.classList.remove('hidden');
            this.errorTarget.textContent = error;
        } else {
            console.warn(error);
        }
    }

    postData(url, data, noReload = false) {
        var xmlHttp = new XMLHttpRequest();
        xmlHttp.onreadystatechange = () => {
            if (xmlHttp.readyState === 4) {
                if (xmlHttp.status === 200) {
                    this._onResponse(JSON.parse(xmlHttp.response), noReload);
                } else if (xmlHttp.status === 400) {
                    const error = JSON.parse(xmlHttp.response).error;
                    this.displayErrorMessage(error);
                } else {
                    console.warn(xmlHttp.status);
                    console.warn(xmlHttp.response);
                }
            }
        };
        xmlHttp.open("POST", url);
        xmlHttp.setRequestHeader("Content-Type", "application/json");
        xmlHttp.send(JSON.stringify(data));
    }

    // Both for adding Members and Admins
    validateEmailAndAddNewMember() {
        const url = this.validationUrl;
        let data = {
            'original_referrer': this.data.get("originalReferrer"),
            'organization_id': this.data.get("organizationId"),
            email: this.memberEmailTarget.value
        };
        if(this.hasPermissionCheckboxTarget){
            let permissions = [];
            this.permissionCheckboxTargets.forEach((input)=> {
                if(input.checked) {
                    permissions.push(input.name);
                }
            });
            data = Object.assign(data, {permissions})
        }
        if (isValidEmail(data.email)) {
            this.postData(url, data);
        } else {
            this.warningTarget.textContent = 'Email provided in an incorrect format.';
            this.warningWrapperTarget.classList.remove('hidden');
            if (!this.errorWrapperTarget.classList.contains('hidden')) {
                this.errorWrapperTarget.classList.add('hidden');
            }
        }
    }

    get validationUrl() {
        return this.data.get("validationUrl");
    }

    _onResponse = ({ html, hasWarnings }, noReload) => {
        if (this.hasErrorTarget && this.hasErrorWrapperTarget) {
            this.errorTarget.textContent = '';
            this.errorWrapperTarget.classList.add('hidden');
        }
        if (this.hasWarningWrapperTarget) {
            if (hasWarnings) {
                this.warningWrapperTarget.classList.remove('hidden');
            } else {
                this.warningWrapperTarget.classList.add('hidden');
            }
        }
        if (!noReload) {
            location.reload();
        }
    }
}
